import * as ambassadorWixRestaurantsMenusV1ItemLabel from './restaurants-menus-v1-item-label-item-labels.http.js';
import * as ambassadorWixRestaurantsMenusV1ItemLabelTypes from './restaurants-menus-v1-item-label-item-labels.types.js';
import * as ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes from './restaurants-menus-v1-item-label-item-labels.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createLabel(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.CreateLabelRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.CreateLabelRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.CreateLabelResponse,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.CreateLabelResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemLabel.createLabel(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/labels',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getLabel(): __PublicMethodMetaInfo<
  'GET',
  { labelId: string },
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.GetLabelRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.GetLabelRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.GetLabelResponse,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.GetLabelResponse
> {
  const payload = { labelId: ':labelId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemLabel.getLabel(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/labels/{labelId}',
    pathParams: { labelId: 'labelId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listLabels(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.ListLabelsRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.ListLabelsRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.ListLabelsResponse,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.ListLabelsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemLabel.listLabels(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/labels',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryLabels(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.QueryLabelsRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.QueryLabelsRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.QueryLabelsResponse,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.QueryLabelsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemLabel.queryLabels(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/labels/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countLabels(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.CountLabelsRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.CountLabelsRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.CountLabelsResponse,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.CountLabelsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemLabel.countLabels(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/labels/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateLabel(): __PublicMethodMetaInfo<
  'PATCH',
  { labelId: string },
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.UpdateLabelRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.UpdateLabelRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.UpdateLabelResponse,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.UpdateLabelResponse
> {
  const payload = { label: { id: ':labelId' } } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemLabel.updateLabel(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/labels/{label.id}',
    pathParams: { labelId: 'labelId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteLabel(): __PublicMethodMetaInfo<
  'DELETE',
  { labelId: string },
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.DeleteLabelRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.DeleteLabelRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.DeleteLabelResponse,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.DeleteLabelResponse
> {
  const payload = { labelId: ':labelId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemLabel.deleteLabel(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/labels/{labelId}',
    pathParams: { labelId: 'labelId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteLabels(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.BulkDeleteLabelsRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.BulkDeleteLabelsRequest,
  ambassadorWixRestaurantsMenusV1ItemLabelUniversalTypes.BulkDeleteLabelsResponse,
  ambassadorWixRestaurantsMenusV1ItemLabelTypes.BulkDeleteLabelsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemLabel.bulkDeleteLabels(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/bulk/labels/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Label as LabelOriginal,
  Image as ImageOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ExternalReferenceInfo as ExternalReferenceInfoOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateLabelRequest as CreateLabelRequestOriginal,
  CreateLabelResponse as CreateLabelResponseOriginal,
  GetLabelRequest as GetLabelRequestOriginal,
  GetLabelResponse as GetLabelResponseOriginal,
  ListLabelsRequest as ListLabelsRequestOriginal,
  ListLabelsResponse as ListLabelsResponseOriginal,
  QueryLabelsRequest as QueryLabelsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryLabelsResponse as QueryLabelsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  CountLabelsRequest as CountLabelsRequestOriginal,
  CountLabelsResponse as CountLabelsResponseOriginal,
  UpdateLabelRequest as UpdateLabelRequestOriginal,
  UpdateLabelResponse as UpdateLabelResponseOriginal,
  DeleteLabelRequest as DeleteLabelRequestOriginal,
  DeleteLabelResponse as DeleteLabelResponseOriginal,
  BulkDeleteLabelsRequest as BulkDeleteLabelsRequestOriginal,
  BulkDeleteLabelsResponse as BulkDeleteLabelsResponseOriginal,
  BulkDeleteLabelsResult as BulkDeleteLabelsResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  CloneLabelsRequest as CloneLabelsRequestOriginal,
  CloneLabelsResponse as CloneLabelsResponseOriginal,
  SyncContentToMultilingualRequest as SyncContentToMultilingualRequestOriginal,
  SyncContentToMultilingualResponse as SyncContentToMultilingualResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CountLabelsApplicationErrors as CountLabelsApplicationErrorsOriginal,
} from './restaurants-menus-v1-item-label-item-labels.types.js';
